import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronRight } from "lucide-react";

/**
 * Breadcrumbs — visible nav + matches JSON-LD BreadcrumbList in Seo component.
 * items: [{name, path}, …]  (Home is added automatically)
 */
export const Breadcrumbs = ({ items = [] }) => {
  const { t } = useTranslation();
  if (items.length === 0) return null;
  return (
    <nav
      data-testid="breadcrumbs"
      aria-label={t("breadcrumbs.label", "Broodkruimels")}
      className="mx-auto max-w-7xl px-6 pt-8 text-xs uppercase tracking-[0.18em] text-[hsl(var(--ink-soft))] lg:px-10"
    >
      <ol className="flex flex-wrap items-center gap-2">
        <li>
          <Link to="/" className="hover:text-[hsl(var(--ink))]">{t("common.home", "Home")}</Link>
        </li>
        {items.map((b, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={b.path} className="flex items-center gap-2">
              <ChevronRight className="h-3 w-3" strokeWidth={1.8} />
              {isLast ? (
                <span className="text-[hsl(var(--ink))]" aria-current="page">{b.name}</span>
              ) : (
                <Link to={b.path} className="hover:text-[hsl(var(--ink))]">{b.name}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
